import { formatINR } from "@/lib/format";

const TH = "px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565]";
const TYPE_COLOR = {
  asset: "#2E6F40", liability: "#D94F3D", equity: "#A67C00", income: "#2E6F40", expense: "#D94F3D",
};

/** Trial balance table: every account's net debit/credit, with balanced totals. Rows drill into the GL. */
export function TrialBalanceTable({ data, onSelect }) {
  if (!data) return null;
  return (
    <section className="border border-[#D8D4C7] bg-white" data-testid="trial-balance">
      <div className="border-b border-[#1A1F16] px-6 py-4 flex items-center justify-between">
        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6C7565]">Statement</div>
          <h3 className="font-serif text-3xl tracking-tight">Trial Balance.</h3>
        </div>
        <span
          data-testid="tb-balanced-badge"
          className={`px-3 py-1.5 text-[10px] uppercase tracking-widest border ${
            data.balanced ? "border-[#2E6F40] text-[#2E6F40]" : "border-[#D94F3D] text-[#D94F3D]"
          }`}
        >
          {data.balanced ? "Balanced ✓" : "Out of balance"}
        </span>
      </div>

      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-[#1A1F16] text-left">
            <th className={TH}>Code</th>
            <th className={TH}>Account</th>
            <th className={`${TH} text-right`}>Debit</th>
            <th className={`${TH} text-right`}>Credit</th>
          </tr>
        </thead>
        <tbody>
          {data.rows.length === 0 ? (
            <tr><td colSpan={4} className="px-4 py-10 text-center text-[#6C7565]">No ledger activity in this period.</td></tr>
          ) : data.rows.map((r) => (
            <tr
              key={r.code}
              onClick={() => onSelect && onSelect(r)}
              className="border-b border-[#EAE7DD] hover:bg-[#FDFBF7] cursor-pointer"
              title="Click to view all postings"
              data-testid={`tb-row-${r.code}`}
            >
              <td className="px-4 py-2.5 num text-[#6C7565]">{r.code}</td>
              <td className="px-4 py-2.5">
                <span>{r.name}</span>
                <span className="ml-2 font-mono text-[9px] uppercase tracking-wider" style={{ color: TYPE_COLOR[r.type] }}>{r.type}</span>
              </td>
              <td className="px-4 py-2.5 text-right num">{r.debit ? formatINR(r.debit) : "—"}</td>
              <td className="px-4 py-2.5 text-right num">{r.credit ? formatINR(r.credit) : "—"}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-[#1A1F16] text-[#F7F5F0]">
            <td className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest" colSpan={2}>Totals</td>
            <td className="px-4 py-3 text-right num font-serif text-lg" data-testid="tb-total-debit">{formatINR(data.total_debit)}</td>
            <td className="px-4 py-3 text-right num font-serif text-lg" data-testid="tb-total-credit">{formatINR(data.total_credit)}</td>
          </tr>
        </tfoot>
      </table>
    </section>
  );
}
